@switch (state()) { @case (stateSubmitted) {
<span
  [attr.aria-label]="'Export submitted' | translate"
  class="pill pill-warn"
  translate
  >submitted</span
>
} @case (stateQueued) {
<span
  [attr.aria-label]="'Export queued' | translate"
  class="pill pill-warn"
  translate
  >queued</span
>
} @case (stateAccepted) {
<span
  [attr.aria-label]="'Export accepted' | translate"
  class="pill pill-warn"
  translate
  >accepted</span
>
} @case (stateInitialized) {
<span
  [attr.aria-label]="'Export accepted' | translate"
  class="pill pill-warn"
  translate
  >accepted</span
>
} @case (stateProcessing) {
<span
  [attr.aria-label]="'Export processing' | translate"
  class="pill pill-success"
  translate
  >processing</span
>
} @case (stateDownloading) {
<span
  [attr.aria-label]="'Export downloading' | translate"
  class="pill pill-success"
  translate
  >downloading</span
>
} @case (statePreprocessing) {
<span
  [attr.aria-label]="'Export preprocessing' | translate"
  class="pill pill-success"
  translate
  >preprocessing</span
>
} @case (stateFinalizing) {
<span
  [attr.aria-label]="'Export finalizing' | translate"
  class="pill pill-success"
  translate
  >finalizing</span
>
} @case (stateCancelled) {
<span
  [attr.aria-label]="'Export cancelled' | translate"
  class="pill pill-danger"
  translate
  >cancelled</span
>
} @case (stateFailed) {
<span
  [attr.aria-label]="'Export failed' | translate"
  class="pill pill-danger"
  translate
  >failed</span
>
} }
